import { render, staticRenderFns } from "./sharePopup.vue?vue&type=template&id=1543ac63&"
import script from "./sharePopup.vue?vue&type=script&lang=js&"
export * from "./sharePopup.vue?vue&type=script&lang=js&"
import style0 from "./sharePopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports